import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  createCoachingFeed,
  updateCoachingFeed,
} from "reduxStore/actions/coachingFeedActions";

const phases = ["Identify", "Action Step", "Model", "Review"];

const CoachingFeedFormDialog = ({
  open,
  handleClose,
  initialData = null,
  userId,
}) => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    date: "",
    phase: "",
    focusUrl: "",
    notes: "",
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        date: initialData.date?.slice(0, 10) || "",
        phase: initialData.phase || "",
        focusUrl: initialData.focusUrl || "",
        notes: initialData.notes || "",
      });
    } else {
      setForm({
        date: "",
        phase: "",
        focusUrl: "",
        notes: "",
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.date || !form.phase) return;

    const payload = {
      ...form,
      user: userId,
    };

    if (initialData?._id) {
      await dispatch(updateCoachingFeed(initialData._id, payload));
    } else {
      await dispatch(createCoachingFeed(payload));
    }

    handleClose();
  };

  function handlePhaseNames(orginalName) {
    if (orginalName === "Review") return "Rehearse (and review)";
    else if (orginalName === "Model") return "Model (and script)";
    else return orginalName;
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {initialData ? "Edit Entry" : "New Coaching Entry"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Date"
          name="date"
          type="date"
          fullWidth
          value={form.date}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Phase"
          name="phase"
          select
          fullWidth
          value={form.phase}
          onChange={handleChange}
          margin="normal"
        >
          {phases.map((p) => (
            <MenuItem key={p} value={p}>
              {handlePhaseNames(p)}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Focus URL"
          name="focusUrl"
          fullWidth
          value={form.focusUrl}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          label="Coaching Notes"
          name="notes"
          fullWidth
          multiline
          minRows={4}
          value={form.notes}
          onChange={handleChange}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          {initialData ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CoachingFeedFormDialog;
